import styled from "@emotion/styled";
import { ThemeStyle } from "assets/scss/common/theme";


export const SectionTitleWrapper = styled.div<{ theme: Theme }>`
  margin-bottom: ${({ theme }) => theme.sectionTitleSpacingBottom};
`;

export const SectionWrapper = styled.div<{ theme: Theme }>`
  margin-bottom: ${({ theme }) => theme.sectionSpacingY};
`;

export const OtherPaymentTitleWrapper = styled.div`
  display: ${({ theme }: ThemeStyle) => theme.otherPaymentMethodTitleDisplay};
  padding: 16px;
`;

export const BuyerAssuranceWrapper = styled.div<{ theme: Theme }>`
  margin-bottom: 90px;

  .buyer-assurance {
    display: ${({ theme }) => theme.displayBuyerAssurancePP1};
  }
`;

export const CouponTitleWrapper = styled.div<{ theme: Theme }>`
  margin: 0 20px 16px;
`;

export const CouponWrapper = styled.div<{ theme: Theme }>`
  display: flex;
  gap: 12px;
  margin-bottom: ${({ theme }) => theme.sectionSpacingY};
  flex-wrap: nowrap;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  -ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
  & > * {
    flex: 0 0 auto;
  }
  .coupon-card:first-child {
    margin-left: 20px;
  }
  .coupon-card:last-child {
    margin-right: 20px;
  }
`;

export const LoginCTAWrapper = styled.div<{ theme: Theme }>`
  background-color: ${({ theme }) => theme.colors.white};
  ${({ theme }) => theme.borders.border100};
  border-color: ${({ theme }) => theme.colors.borderTertiary};
  border-radius: ${({ theme }: ThemeStyle) => theme.borders.radiusPrimary};
  padding: 16px;
  margin: 0 20px ${({ theme }) => theme.sectionSpacingY};
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const DeliveryEstimateBuyNowWrapper = styled.div`
  margin-bottom: 10px;
`;
